import { Color, FontSize, Spacing } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const headerPdfStyles = StyleSheet.create({
  container: {
    marginBottom: Spacing.S24,
    borderBottomWidth: 1,
    borderBottomColor: Color.Grey200,
    borderBottomStyle: 'solid',
    paddingBottom: Spacing.S2,
  },
  titleWrapper: {
    gap: Spacing.S4,
    paddingVertical: Spacing.S2,
    paddingHorizontal: Spacing.S4,
  },
  titleText: {
    fontSize: FontSize.TextBodyMD,
    fontWeight: 'medium',
  },
  metaWrapper: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: Spacing.S4,
    paddingVertical: Spacing.S2,
    paddingHorizontal: Spacing.S4,
  },
  metaText: {
    fontSize: '10px',
    color: Color.Grey500,
  },
  dates: {
    alignSelf: 'flex-end',
  },
})
